export const ProfilePage = () => {
  return <></>;
};
